/** Cấu hình runtime của frontend (đọc từ biến VITE_* lúc build/dev). */
export const APP_CONFIG = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, ''),
  apiPrefix: '/api/v1',
} as const;

/** URL bắt đầu đăng nhập SSO ở backend (backend đổi code lấy token — IntegrateSSOGuide.md). */
export function ssoLoginUrl(returnTo: string): string {
  return `${APP_CONFIG.apiBaseUrl}${APP_CONFIG.apiPrefix}/auth/sso/login?returnTo=${encodeURIComponent(
    returnTo,
  )}`;
}

export function ssoLogoutUrl(): string {
  return `${APP_CONFIG.apiBaseUrl}${APP_CONFIG.apiPrefix}/auth/sso/logout`;
}
